module.exports = __webpack_public_path__ + "km.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/fonts/flag-icon-css/flags/4x3/km.svg
// module id = 639
// module chunks = 0